export const MQTT_DEFAULT_JSON = {
  periodic_log: `{
    "timestamp": 1747994728, // Unix Timestamp
    "camera_id": "6634ea4d-9389-4b45-9502-a7a7471a79b6", // Unique ID for the camera
    "app_id": "zvMWm7jZ", // Unique ID for the app
    "frame_width": 0, // Frame width
    "frame_height": 0, // Frame height
    "fps": 5, // Current FPS of the camera
    "is_alive": true, // Boolean value to check if the app is alive
    "count_area1": 2, // Count of objects in ROI
    "count_area1_license plate": 2, // Count of specific label in ROI
    "frame_number": 49, // Current frame number
    "camera_name": "office stream", // Name of the camera
    "frame_timestamp": 1747994728316822000, // Frame timestamp in nanoseconds
    "detections": [
      {
        "label_name": "license plate",
        "confidence": 0.6714787483215332,
        "tracker_id": 1,
        "bbox": [
          418.92034912109375,
          599.3653564453125,
          258.57330322265625,
          87.15231323242188
        ],
        "ROI": [
          "area1"
        ],
        "dwell_time": {
          "area1": 8.21
        }
      },
      {
        "label_name": "license plate",
        "confidence": 0.7983133792877197,
        "tracker_id": 2,
        "bbox": [
          733.699462890625,
          509.2668151855469,
          258.2350158691406,
          73.76606750488281
        ],
        "ROI": [
          "area1"
        ],
        "dwell_time": {
          "area1": 8.21
        }
      }
    ]
  }`,
  event_log: `{
    "timestamp": 1747996886, // Unix Timestamp
    "camera_id": "6634ea4d-9389-4b45-9502-a7a7471a79b6", // Unique ID for the camera
    "app_id": "zvMWm7jZ", // Unique ID for the app
    "frame_width": 0, // Frame width
    "frame_height": 0, // Frame height
    "dwell_time": 27, // Dwell time in seconds
    "triggered_line": "", // Line Name
    "triggered_roi": "area1", // ROI Name that was triggered
    "object_direction": "None", // Direction of the object
    "tracker_id": 1, // Tracker ID
    "triggered_label_name": "license plate", // Label Name that was triggered
    "triggered_label_confidence": 67.68256425857544, // Confidence of the triggered label
    "camera_name": "office stream" // Name of the camera
  }`
}

export const MQTT_OINSIGHTS_JSON = {
  periodic_log: `{
    "timestamp": 1747994791, // Unix Timestamp
    "camera_id": "6634ea4d-9389-4b45-9502-a7a7471a79b6", // Unique ID for the camera
    "app_id": "zvMWm7jZ", // Unique ID for the app
    "frame_width": 0, // Frame width
    "frame_height": 0, // Frame height
    "fps": 3, // Current FPS of the camera
    "is_alive": true, // Boolean value to check if the app is alive
    "count_area1": 2, // Count of objects in ROI
    "count_area1_license plate": 2, // Count of specific label in ROI
    "frame_number": 399, // Current frame number
    "camera_name": "office stream", // Name of the camera
    "frame_timestamp": 1747994791550583000 // Frame timestamp in nanoseconds
  }`,
  event_log: `{
    "timestamp": 1747996886, // Unix Timestamp
    "camera_id": "6634ea4d-9389-4b45-9502-a7a7471a79b6", // Unique ID for the camera
    "app_id": "zvMWm7jZ", // Unique ID for the app
    "frame_width": 0, // Frame width
    "frame_height": 0, // Frame height
    "dwell_time": 27, // Dwell time in seconds
    "triggered_line": "", // Line Name
    "triggered_roi": "area1", // ROI Name that was triggered
    "object_direction": "None", // Direction of the object
    "tracker_id": 1, // Tracker ID
    "triggered_label_name": "license plate", // Label Name that was triggered
    "triggered_label_confidence": 67.68256425857544, // Confidence of the triggered label
    "camera_name": "office stream" // Name of the camera
  }`
}
